export enum Keys {
  Escape = 'Escape',
  Enter = 'Enter',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Tab = 'Tab',
  Copy = 'KeyC',
  Paste = 'KeyV',
  D = 'KeyD',
  S = 'KeyS',
  V = 'KeyV',
  // action bar tools (OCT-5195)
  C = 'KeyC',
  N = 'KeyN',
  E = 'KeyE',
  I = 'KeyI',

  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',

  Z = 'KeyZ',
  ZoomIn = 'Equal',
  ZoomOut = 'Minus',
  ZoomReset = 'Digit0',
  ZoomFit = 'Digit1',

  Search = 'KeyF',
}
